import { h, JSX } from 'preact';
import {ProductButtonGrid, ProductButtonGridProps} from './ProductButtonGrid';
import {EditGridModal, EditGridModalProps} from './EditGridModal';
import classNames from 'classnames';

export interface EditGridProps {
    navigation: {
        name: string,
        url: string,
        current: boolean,
    }[];
    grid: ProductButtonGridProps
    editModal: EditGridModalProps
    onSave: () => void
    saveButtonLabel: string
}

export const EditGrid = (props: EditGridProps): JSX.Element => (
    <div class='mt-4'>
        <div class='flex gap-2 justify-between'>
            {props.navigation && (
                <nav class='mb-6 overflow-auto'>
                    <ul class='flex gap-4'>
                        {props.navigation.map(((navItem) => (
                            <li>
                                <a
                                    class={classNames(
                                        'btn px-4 py-3',
                                        navItem.current ? 'btn-dark-blue' : 'btn-border'
                                    )}
                                    href={navItem.url}
                                >
                                    {navItem.name}
                                </a>
                            </li>
                        )))}
                    </ul>
                </nav>
            )}
            {props.onSave && (
                <div>
                    <button class='btn btn-green px-4 py-3' onClick={props.onSave}>
                        {props.saveButtonLabel}
                    </button>
                </div>
            )}
        </div>
        <ProductButtonGrid {...props.grid}/>
        {props.editModal && (
            <EditGridModal {...props.editModal}/>
        )}
    </div>
)
